/**Packages */
import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

/* Helpers */
import { trackCustomPageview, trackCFAndPhone } from '../../../helpers/GTMEvents'
import { getPartnerEndpoints } from '../../../helpers/settings/partnerEndpoints';
import { handleAPIRequest } from '../../../helpers/handleAPIRequest';
import { getPixelData } from '../../../helpers/utils';
import { manageAssistant } from '../../../helpers/assistant';

/* Redux */
import { useDispatch, useSelector } from 'react-redux';
import { setUserDataThunk } from '../../../redux/actions/index';

/* Components */
import { Header } from '../../shared/Header';
import { Button } from '../../shared/Button';
import { Input } from '../../shared/Input';
import { MainContentWrapper } from '../../shared/MainContentWrapper';
import { PageHeading } from '../../shared/PageHeading';
import { PageSubtitle } from '../../shared/PageSubtitle';
import { Footer } from '../../shared/Footer';
import { Spinner } from '../../shared/Spinner';
import { HiddenButton } from '../../shared/HiddenButton';
import { BizmaticaHiddenForm } from '../../shared/BizmaticaHiddenForm';

/**CSS */
import './style.css';

// Get an instance of `PhoneNumberUtil`.
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();


const checkCF = (cf) => {
  const regex = /^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i;
  return regex.test(String(cf).toLowerCase());
}

const checkPhone = (phone) => {
  if(
    !phone 
    || phone === '' 
    || phone === '+393' 
    || phone.length < 12
    
    //Commented on 29/07/21 on Compass request
    //|| phone.length < 13
  
    ) return false;
  try {
    const region = 'IT';
    const value = phoneUtil.parseAndKeepRawInput(phone, region);
    return phoneUtil.isValidNumberForRegion(value, region);
  } catch(e) {
    return false;
  }
}

export const DatiForm = (props) => {
    const [loaderIsVisibile, setLoaderVisibility] = useState(false);
    const [submitButtonIsEnable, setSubmitButtonClickability] = useState(false);
    const [ fiscalCode, setFiscalCode ] = useState('');
    const [ phone, setPhone ] = useState('+39');
    const [ useSubmit, setUseSubmit ] = useState(false);
    const [responseError, setResponseError] = useState('');
    
    const dispatch = useDispatch();
    const setUserData = (payload) => dispatch(setUserDataThunk(payload));
    const passedFromSimulation = useSelector(state => state.passed?.fromSimulation);
    
    const innerButtonRef = useRef(null);
    
    const history = useHistory();
    const location = useLocation();
    const { search = '' } = location;

    const goToBizmaticaForm = () => {
      innerButtonRef?.current?.click();
    }

    const handleSubmit = function (event) {
        event.preventDefault();

        if(!checkForm()) return;

        setLoaderVisibility(true);
        setSubmitButtonClickability(checkForm());

        const data = {
          cf: fiscalCode,
          tel: phone.split('+39')[1],
        };

        trackCFAndPhone(...Object.values(data));

        const callbacks = {
          200: {
            success: function (response) {
              const {
                NeedOTP,
                TokenOTP,
                Token,
                Result,
                ResultMessage,
              } = response.data;
              
              if(Result && Result.toLowerCase() === 'ok') {
                
                data.token = Token;
                data.tokenOTP = TokenOTP;
                
                setUserData(data);

                if(NeedOTP) {
                  history.push(`/conferma-otp.html${search}`);
                } else {
                  setUseSubmit(true);
                  goToBizmaticaForm();
                }
              } else {
                if(!NeedOTP) {
                  setUserData(data);
                  setUseSubmit(true);
                  goToBizmaticaForm();
                } else {
                  setSubmitButtonClickability(true);
                  setUseSubmit(true);
                  goToBizmaticaForm();
                  //setResponseError('Qualcosa è andato storto. Riprova più tardi');
                }
              }
            },
            error: function (response) {
              setLoaderVisibility(false);
              setSubmitButtonClickability(true);
              setUseSubmit(true);
              goToBizmaticaForm();
              //setResponseError('Qualcosa è andato storto. Riprova più tardi');
            },
          },
          400: function () {
            setLoaderVisibility(false);
            setSubmitButtonClickability(true);
            setUseSubmit(true);
            goToBizmaticaForm();
            //setResponseError('Qualcosa è andato storto. Riprova più tardi');
          },
          404: function () {
            setLoaderVisibility(false);
            setSubmitButtonClickability(true);
            setUseSubmit(true);
            goToBizmaticaForm();
            //setResponseError('Qualcosa è andato storto. Riprova più tardi');
          },
          500: function () {
            setLoaderVisibility(false);
            setSubmitButtonClickability(true);
            setUseSubmit(true);
            goToBizmaticaForm();
            //setResponseError('');
          },
          /*
          default: function () {
            setLoaderVisibility(false);
            setSubmitButtonClickability(true);
            setResponseError('Qualcosa è andato storto. Riprova più tardi');
          },
          */
        };
        
        handleAPIRequest(
          {
            method: 'post',
            url: getPartnerEndpoints("compass").api.checkUserData,
            headers: {
              'Content-Type': 'application/json',
            },
            data: data,
          },
          callbacks,
          true
        );
    };

    function handlePhone(value){
        if( 
            value.length > 2 
            && value.length <= 18 
            && value.startsWith('+39') 
        ) {
          setPhone(value);
        } else if(value.length === 0){
          setPhone('+39');
        }

        setResponseError('');
        setSubmitButtonClickability(checkForm());
    }

    function handleCF(value) {
      if(value.length < 16 || (value.length === 16 && checkCF(value.toUpperCase()))) {
        setFiscalCode(value.toUpperCase());
      }

      setResponseError('');
      setSubmitButtonClickability(checkForm());
    }

    function onPhoneFocus() {
      if(phone === '' || phone === '+39') {
        setPhone('+39');
      }

      setResponseError('');
      setSubmitButtonClickability(checkForm());
    }

    function onPhoneBlur() {
      if(phone.length <= 3) {
        setPhone('');
      }

      setResponseError('');
      setSubmitButtonClickability(checkForm());
    }
    
    function onCFFocus() {
      setResponseError('');
      setSubmitButtonClickability(checkForm());
    }

    function onCFBlur() {
      setResponseError('');
      setSubmitButtonClickability(checkForm());
    }
    
    function checkForm() {
      const valid = !window.$("#user-form").validate().errorList || window.$("#user-form").validate().errorList.length <= 0;
      if(
          valid 
          && checkCF(fiscalCode)
          && checkPhone(phone)
        ) {
        return true;
      }

      return false;
    }

    /**Check if user is trying to access directly the page*/
    useEffect(() => {
      if(!passedFromSimulation) {
        history.push('/simulatore-commerciale.html');
      } else {
        getPixelData('/dati-utente.html');
        window.$("html, body").animate({ scrollTop: 0 },"slow");
        trackCustomPageview();
        manageAssistant();
      }
    }, []);

    /**Check phone and fiscalCode */
    useEffect(() => {
      setResponseError('');
      setSubmitButtonClickability(checkForm());
    }, [phone, fiscalCode, setPhone, setFiscalCode]);

    return (
      <div className="wrapper">
            <Spinner visible={loaderIsVisibile} />
            <Header
                logo={
                    { 
                        image: './images/logo_compass.png',
                        alt: 'Logo compass',
                        redirect: `/simulatore/simulatore-commerciale.html${search}`,
                    }
                }
                isSimulator={true}
            />
            <MainContentWrapper id="form-utente" mainClass="page-content col-xs-12 col-md-10 offset-md-1 module-deps" isSimulator={false} maxWidthHandler={false} >
                <PageHeading title="Il tuo prestito" isSimulator={true}/>
                <PageSubtitle 
                    text={
                        "<p>Inserisci il tuo <strong>codice fiscale</strong> e il tuo <strong>numero di cellulare</strong> per procedere.</p>"
                    }
                    alignment="center"
                />
                <form id="user-form" className="m-t-1 d-flex justify-content-center flex-column" action="#" onSubmit={(event) => handleSubmit(event)}>
                    <div className="row">
                        <div className="col-xs-12 col-sm-8 offset-sm-2 col-md-6 offset-md-0">
                            <Input
                                className="fiscal-code required"
                                type="text"
                                name="fiscal-code"
                                required="required"
                                value={fiscalCode}
                                onChange={(event) => handleCF(event.target.value)}
                                onFocus={onCFFocus}
                                onBlur={onCFBlur}
                                label="Codice Fiscale"
                            />
                        </div>
                        <div className="col-xs-12 col-sm-8 offset-sm-2 col-md-6 offset-md-0">
                            <Input
                                className="phone-input phone mobile-phone required"
                                type="tel"
                                pattern="[0-9]*"
                                name="phone"
                                value={phone}
                                required="required"
                                onChange={(event) => handlePhone(event.target.value)}
                                onFocus={onPhoneFocus}
                                onBlur={onPhoneBlur}
                                label="Numero di telefono"
                            />
                        </div>
                    </div>
                  <div className="row">
                    <p className="small-text-container col-xs-12 col-md-10 offset-md-1">
                        Prendi visione dell'informativa resa da Compass ai sensi degli artt. 13 e 14 del Regolamento UE 2016/679 e della normativa nazionale vigente in materia di protezione dei dati personali <a target="_blank" href="pdf/CQ002.pdf" rel="noopener noreferrer">qui scaricabile</a>.
                    </p>
                  </div>
                  <Button 
                    isSimulator={true} 
                    color="red" 
                    text="Procedi" 
                    className="submit-button" 
                    type="submit"
                    clickEvent={handleSubmit}
                    disabled={!submitButtonIsEnable}
                    onMouseOver={checkForm}  
                    onMouseOut={checkForm}  
                  />
                  {responseError ? <p className="response-error">{responseError}</p> : null}
                </form>
              <BizmaticaHiddenForm useSubmit={useSubmit} returnUrl={`${window.location.origin}`} >
                  <HiddenButton innerRef={innerButtonRef}/>
              </BizmaticaHiddenForm>
            </MainContentWrapper>
            <Footer 
              isSimulator={true}
              showDynamicParagraph={false}
              textToUse="©Compass Banca S.p.A., socio unico direzione e coordinamento Mediobanca S.p.A., N. iscr. R.I. di Milano C.F. e P.I. 00864530159"
            />
        </div>
      );
};

export default DatiForm;